import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Tag,
  Select,
  DatePicker,
  Tabs,
  Button,
  Spin,
  Empty,
  Modal,
  Avatar,
  Radio,
  message,
  Tooltip as AntTooltip,
} from "antd";

import {
  BankOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  CarOutlined,
  AimOutlined,
  SyncOutlined,
  ShoppingOutlined,
  ShopOutlined,
  PartitionOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import domtoimage from "dom-to-image-more";

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";

import "./newDashboard.css";
import MovementFlowMap from "./MovementFlowMap";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import { LanguageContext } from "../../context/LanguageContext";
import dayjs from "dayjs";
import moment from "moment";
import TabPane from "antd/lib/tabs/TabPane";
import { adminService } from "../../_services/admin.service";
import config from "../../config";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
const { Option } = Select;
const { RangePicker } = DatePicker;

const formatDateRange = (dates) => {
  if (!dates?.[0] || !dates?.[1]) return "";
  return `${moment(dates[0]).format("DD/MM/YYYY")} - ${moment(dates[1]).format("DD/MM/YYYY")}`;
};

const formatModalCount = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString("en-IN");
};

class NewDashboard extends Component {
  static contextType = LanguageContext;
  state = {
    main_head: [],
    advancedFilterTitle: "मोडस",
    crimeTitle: ["all"],
    selectedHeadings: [],
    dateFilter: "1month",
    customDates: [moment().subtract(1, "month"), moment()],
    district_name: "",
    kayda: null,
    kalam: [],
    newDashboardLoading: true,
    movementModalVisible: false,
    movementModalLoading: false,
    movementModalData: null,
    movementModalView: "list",
    topAccusedMovementTab: "outside",
    /** हद्दीत राहून बाहेर = outsider (first / default) */
    headingBarMovementTab: "outsider",
    setCriminalViewModel: false,
    showGunaDetails: false,
    gunaLoading: false,
  };

  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };

  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };

  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  handleDateFilterChange = (value) => {
    let dates = [];

    if (value === "1month") {
      dates = [moment().subtract(1, "month"), moment()];
    }

    if (value === "6month") {
      dates = [moment().subtract(6, "month"), moment()];
    }

    if (value === "1year") {
      dates = [moment().subtract(1, "year"), moment()];
    }

    this.setState({
      dateFilter: value,
      customDates: dates,
    });
  };

  getMainHead = () => {
    professionalAction.getMainHead().then((res) => {
      console.log("res", res.data);
      this.setState({
        main_head: res.data,
      });
    });
  };
  handleChange = (dates) => {
    this.setState({
      dates,
    });
  };

  handleKala = (e) => {
    this.setState({
      kayda: e,
      kalam: [],
    });
    this.props.dispatch(professionalAction.getKalam(e));
  };

  getNewDashboardRequestBody = () => {
    const { user } = this.props;
    const {
      customDates,
      advancedFilterTitle,
      crimeTitle,
      selectedHeadings,
      kayda,
      kalam,
    } = this.state;
    return {
      district: user.districtId,
      cityId: user.cityId,
      startDate: moment(customDates[0]).format("YYYY-MM-DD"),
      endDate: moment(customDates[1]).format("YYYY-MM-DD"),
      title: advancedFilterTitle,
      heading:
        advancedFilterTitle === "मोडस"
          ? crimeTitle === "all"
            ? null
            : crimeTitle
          : advancedFilterTitle === "शीर्षक"
            ? Array.isArray(selectedHeadings) &&
              selectedHeadings.length > 0 &&
              selectedHeadings[0].toString() !== "all"
              ? selectedHeadings
              : null
            : advancedFilterTitle === "लघु शीर्षक"
              ? Array.isArray(crimeTitle) &&
                crimeTitle.length > 0 &&
                crimeTitle[0].toString() !== "all"
                ? crimeTitle
                : null
              : null,
      kayda: advancedFilterTitle === "कायदा" ? kayda : null,
      kalam:
        advancedFilterTitle === "कायदा"
          ? Array.isArray(kalam) &&
            kalam.length > 0 &&
            kalam[0].toString() !== "all"
            ? kalam
            : null
          : null,
    };
  };

  resolveMovementPhotoUrl = (photo) => {
    if (!photo || typeof photo !== "string") return null;
    const p = photo.trim();
    if (/^https?:\/\//i.test(p)) return p;
    const base = (config.apiGateway && config.apiGateway.baseUrl) || "";
    return `${String(base).replace(/\/$/, "")}/${p.replace(/^\//, "")}`;
  };

  openMovementCardDetail = (flowSide, item) => {
    const linkedDistrictId =
      item && (item.district != null ? item.district : item.id);
    if (linkedDistrictId == null) return;

    const payload = {
      ...this.getNewDashboardRequestBody(),
      flowSide,
      linkedDistrictId,
    };

    this.setState({
      movementModalVisible: true,
      movementModalLoading: true,
      movementModalData: null,
      movementModalView: "list",
    });

    adminService
      .newDashboardMovementCardDetail(payload)
      .then((res) => {
        if (res && res.success && res.data) {
          this.setState({ movementModalData: res.data });
        } else {
          this.setState({ movementModalData: null });
        }
      })
      .catch(() => {
        this.setState({ movementModalData: null });
      })
      .finally(() => {
        this.setState({ movementModalLoading: false });
      });
  };

  closeMovementModal = () => {
    this.setState({
      movementModalVisible: false,
      movementModalData: null,
      movementModalLoading: false,
      movementModalView: "list",
    });
  };

  getMovementModalRows = (movementModalData) => {
    if (!movementModalData) return [];
    return (
      movementModalData.movementRows || movementModalData.accusedList || []
    );
  };

  getMovementModusPie = (movementModalData) => {
    if (!movementModalData) return [];
    const fromApi =
      movementModalData.modus_pie || movementModalData.modusBreakdown;
    return Array.isArray(fromApi) ? fromApi : [];
  };

  getMovementChartFileBase = () => {
    const { movementModalData } = this.state;
    if (!movementModalData) return "CMIS_movement_modus";
    const hub = String(movementModalData.hubDistrictName || "hub").replace(
      /[^\w]+/g,
      "_",
    );
    const linked = String(
      movementModalData.linkedDistrictName || "linked",
    ).replace(/[^\w]+/g, "_");
    const flow = movementModalData.flowSide === "out" ? "outgoing" : "incoming";
    return `CMIS_${flow}_${hub}_${linked}`;
  };

  downloadMovementChartAsImage = (elementId, labelSuffix) => {
    const node = document.getElementById(elementId);
    if (!node) {
      message.warning("चार्ट सापडला नाही");
      return;
    }
    const fileName = `${this.getMovementChartFileBase()}_${labelSuffix}_${moment().format("DDMMMYYYY")}.png`;
    domtoimage
      .toPng(node, {
        bgcolor: "#fafcff",
        cacheBust: true,
        style: {
          transform: "scale(1)",
          transformOrigin: "top left",
        },
      })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = fileName;
        link.href = dataUrl;
        link.click();
      })
      .catch(() => {
        message.error("चित्र डाउनलोड अयशस्वी");
      });
  };

  renderMovementChartDownloadButton = (elementId, labelSuffix) => (
    <AntTooltip title="Download chart as PNG">
      <Button
        type="default"
        size="small"
        className="nd-btn nd-btn--png"
        icon={<DownloadOutlined />}
        onClick={() =>
          this.downloadMovementChartAsImage(elementId, labelSuffix)
        }
      >
        PNG
      </Button>
    </AntTooltip>
  );

  renderMovementSingleBarSection = (
    data,
    title,
    chartExportId = "nd-movement-modus-chart",
  ) => {
    if (!data || data.length === 0) {
      return (
        <div className="nd-movement-modal__chart-box nd-movement-modal__chart-box--empty">
          <h3 className="nd-movement-modal__chart-title">{title}</h3>
          <Empty description="डेटा उपलब्ध नाही" />
        </div>
      );
    }

    const chartData = data.map((item) => ({
      name: item.district_name,
      count: Number(item.accused_count || 0),
    }));

    return (
      <div className="nd-movement-modal__chart-card">
        <div className="nd-movement-modal__chart-toolbar">
          <h3 className="nd-movement-modal__chart-toolbar-title">{title}</h3>
          <div className="nd-movement-modal__chart-actions">
            {this.renderMovementChartDownloadButton(chartExportId, "modus_bar")}
          </div>
        </div>
        <div
          id={chartExportId}
          className="nd-movement-modal__chart-box nd-movement-modal__chart-export"
        >
          <h3 className="nd-movement-modal__chart-title">{title}</h3>
          <ResponsiveContainer width="100%" height={380}>
            <BarChart
              data={chartData}
              margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                interval={0}
                angle={-25}
                textAnchor="end"
                height={60}
              />
              <YAxis allowDecimals={false} />
              <Tooltip
                formatter={(value, name) => [
                  value,
                  name === "count" ? "Count" : name,
                ]}
              />
              <Legend />
              <Bar
                dataKey="count"
                name="Count"
                fill="#7c3aed"
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };

  renderMovementModalToggle = () => {
    const { movementModalView } = this.state;
    return (
      <div className="nd-movement-modal__toggle-wrap">
        <div className="nd-movement-modal__toggle">
          <div
            role="button"
            tabIndex={0}
            onClick={() => this.setState({ movementModalView: "list" })}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.setState({ movementModalView: "list" });
              }
            }}
            className={`nd-movement-modal__toggle-btn${
              movementModalView === "list"
                ? " nd-movement-modal__toggle-btn--active"
                : ""
            }`}
          >
            यादी (List)
          </div>
          <div
            role="button"
            tabIndex={0}
            onClick={() => this.setState({ movementModalView: "analysis" })}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.setState({ movementModalView: "analysis" });
              }
            }}
            className={`nd-movement-modal__toggle-btn${
              movementModalView === "analysis"
                ? " nd-movement-modal__toggle-btn--active"
                : ""
            }`}
          >
            विश्लेषण (Analysis)
          </div>
        </div>
      </div>
    );
  };

  getMovementModusChartTitle = (movementModalData) => {
    if (!movementModalData) return "Modus Operandi";
    const selectedDistrict =
      movementModalData.linkedDistrictName || movementModalData.hubDistrictName;
    return selectedDistrict
      ? `Modus Operandi — ${selectedDistrict}`
      : "Modus Operandi — Selected District";
  };

  renderMovementModalAnalysis = (movementModalData) => {
    const modusRows = this.getMovementModusPie(movementModalData);
    const modusChartData = modusRows.map((r) => ({
      district_name: r.modus_name ?? r.district_name,
      accused_count: r.accused_count,
    }));

    return this.renderMovementSingleBarSection(
      modusChartData,
      this.getMovementModusChartTitle(movementModalData),
    );
  };

  renderMovementModalTitle = (movementModalData, dateRangeText) => {
    const titleText = movementModalData
      ? `${
          movementModalData.flowSide === "out"
            ? "हद्दीत राहून बाहेर गुन्हे करणारे"
            : "बाहेरून येऊन हद्दीत गुन्हे करणारे"
        }: ${movementModalData.hubDistrictName ?? ""} ↔ ${
          movementModalData.linkedDistrictName ?? ""
        }`
      : "हद्दीत राहणारे व हद्दीत गुन्हे करणारे";
    const totalCount = formatModalCount(
      this.getMovementModalRows(movementModalData).length,
    );

    return (
      <div className="nd-movement-modal__title">
        <span className="nd-movement-modal__title-text">{titleText}</span>
        <div className="nd-movement-modal__title-meta">
          {dateRangeText ? (
            <span className="nd-movement-modal__date-range">
              <CalendarOutlined />
              {dateRangeText}
            </span>
          ) : null}
          <span className="nd-movement-modal__total-badge">
            एकूण: <strong>{totalCount}</strong>
          </span>
        </div>
      </div>
    );
  };

  NewDashboard = () => {
    const obj = this.getNewDashboardRequestBody();
    this.setState({ newDashboardLoading: true });
    adminService
      .NewDashboard(obj)
      .then((res) => {
        this.setState({
          list: res.data,
        });
      })
      .finally(() => {
        this.setState({ newDashboardLoading: false });
      });
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());
    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
    this.getMainHead();
    this.getDistrictsid();
    this.NewDashboard();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.list !== prevState.list) {
      const l = this.state.list;
      const out =
        l?.topAccusedOutsideMovementRows ?? l?.top_accused_movement ?? [];
      const inn = l?.topAccusedInsideMovementRows ?? [];
      const sam = l?.topAccusedSameDistrictMovementRows ?? [];
      const t = this.state.topAccusedMovementTab;
      const len = { outside: out.length, inside: inn.length, same: sam.length };
      let next = t;
      if (!len[t]) {
        if (len.outside) next = "outside";
        else if (len.inside) next = "inside";
        else if (len.same) next = "same";
      }
      if (next !== t) {
        this.setState({ topAccusedMovementTab: next });
      }

      const hb = l?.heading_top_by_basic_heading;
      if (hb) {
        const lens = {
          outsider: hb.outsider?.length || 0,
          inside: hb.inside?.length || 0,
          same: hb.same?.length || 0,
        };
        const ht = this.state.headingBarMovementTab;
        let hnext = ht;
        if (!lens[ht]) {
          if (lens.outsider) hnext = "outsider";
          else if (lens.inside) hnext = "inside";
          else if (lens.same) hnext = "same";
        }
        if (hnext !== ht) {
          this.setState({ headingBarMovementTab: hnext });
        }
      }
    }
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
    const prevPrevetive = prevProps.professionals?.criminalViewList;
    const currtPrevetive = this.props.professionals?.criminalViewList;
    if (this.state.preventiveLoading && prevPrevetive !== currtPrevetive) {
      this.setState({ preventiveLoading: false });
    }
  }

  handleAdvancedFilterTitleChange = (value) => {
    this.setState({
      advancedFilterTitle: value,
      crimeTitle: ["all"],
      selectedHeadings: [],
    });
  };
  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  handleCrimeChange = (value) => {
    // convert all values to string
    let updated = value.map(String);

    // if all selected with others
    if (updated.includes("all") && updated.length > 1) {
      updated = updated.filter((v) => v !== "all");
    }

    // if empty
    if (updated.length === 0) {
      updated = ["all"];
    }

    this.setState({
      crimeTitle: updated,
    });
  };

  render() {
    const {
      main_head,
      advancedFilterTitle,
      dates,
      selectedHeadings,
      crimeTitle,
      district_name,
      list,
      newDashboardLoading,
      movementModalVisible,
      movementModalLoading,
      movementModalData,
      movementModalView,
      topAccusedMovementTab,
      headingBarMovementTab,
      customDates,
    } = this.state;
    const movementModalDateRange = formatDateRange(customDates);
    const { professionals } = this.props;
    console.log("professionals", professionals);
    const {
      criminalViewList,
      pc_cities,
      loading,
      pc_crimetypes,
      pc_crimetitles,
    } = this.props.professionals;
    const { t } = this.context;
    const outsiderList = list?.movement_outsider_count || [];
    const insiderListRaw =
      list?.movemen_inside_count ||
      list?.movement_inside_count ||
      list?.movement_insider_count ||
      null;
    /** If API omits inside array, reuse same movement list as left (user request) */
    const insiders =
      insiderListRaw && insiderListRaw.length > 0 ? insiderListRaw : [];
    const outsiders = outsiderList;
    const dmvHubPts = { x: 50, y: 50 };
    const dmvSlotPts = {
      tl: { x: 20, y: 24 },
      tr: { x: 80, y: 24 },
      r: { x: 90, y: 50 },
      br: { x: 80, y: 76 },
      bl: { x: 20, y: 76 },
      l: { x: 10, y: 50 },
    };
    const dmvOuterSlots = [
      { pos: "tl", item: outsiders[0] },
      { pos: "tr", item: outsiders[1] },
      { pos: "r", item: outsiders[2] },
    ].filter((s) => s.item);
    const dmvInnerSlots = [
      { pos: "br", item: insiders[0] },
      { pos: "bl", item: insiders[1] },
      { pos: "l", item: insiders[2] },
    ].filter((s) => s.item);
    /** Short hub↔spoke segment so arrows sit clear of cards; both ends trimmed */
    const dmvShortenLine = (hx, hy, tx, ty) => {
      const dx = tx - hx;
      const dy = ty - hy;
      const len = Math.hypot(dx, dy) || 1;
      const ux = dx / len;
      const uy = dy / len;
      const hubPad = Math.min(6.5, len * 0.18);
      const tipPad = Math.min(7.5, len * 0.2);
      return {
        x1: hx + ux * hubPad,
        y1: hy + uy * hubPad,
        x2: tx - ux * tipPad,
        y2: ty - uy * tipPad,
      };
    };
    /** Smooth Q curve between trimmed endpoints; bulge opens away from map center */
    const dmvCurvedPath = (x1, y1, x2, y2) => {
      const mx = (x1 + x2) / 2;
      const my = (y1 + y2) / 2;
      const dx = x2 - x1;
      const dy = y2 - y1;
      const len = Math.hypot(dx, dy) || 1;
      const nx = -dy / len;
      const ny = dx / len;
      const vxm = 50 - mx;
      const vym = 50 - my;
      const dot = vxm * nx + vym * ny;
      const sign = dot > 0 ? -1 : 1;
      const k = Math.min(13, len * 0.44) * sign;
      const cx = mx + nx * k;
      const cy = my + ny * k;
      return `M ${x1} ${y1} Q ${cx} ${cy} ${x2} ${y2}`;
    };
    const pieData = [
      {
        name: "बाहेर जाणारे आरोपी",
        value: list?.outsider_count,
        color: "#1e88e5",
      },
      {
        name: "बाहेरून येणारे आरोपी",
        value: list?.inside_count,
        color: "#43a047",
      },
      {
        name: "स्थानिक आरोपी",
        value: list?.same_count,
        color: "#fb8c00",
      },
    ];

    const topAccusedOutsideRows =
      list?.topAccusedOutsideMovementRows ?? list?.top_accused_movement ?? [];
    const topAccusedInsideRows = list?.topAccusedInsideMovementRows ?? [];
    const topAccusedSameDistrictRows =
      list?.topAccusedSameDistrictMovementRows ?? [];
    const showTopAccusedTable =
      (topAccusedOutsideRows?.length || 0) +
        (topAccusedInsideRows?.length || 0) +
        (topAccusedSameDistrictRows?.length || 0) >
      0;

    const topAccusedTableData =
      topAccusedMovementTab === "inside"
        ? topAccusedInsideRows
        : topAccusedMovementTab === "same"
          ? topAccusedSameDistrictRows
          : topAccusedOutsideRows;
    const getPreventiveStatusKey = (record) => {
      if (
        !record.preventive_records ||
        record.preventive_records.length === 0
      ) {
        return "-";
      }
      const { status } = record.preventive_records[0] || {};
      return status === "completed" || status === "ongoing" ? status : "-";
    };
    const columns = [
      {
        title: "अ.क्र.",
        render: (text, record, index) => index + 1,
      },
      {
        title: t("name_of_the_accused"),
        dataIndex: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        render: (text, record) => (
          <Button
            type="link"
            title={record.masterId}
            onClick={() => {
              this.onViewAccusedForm(record.masterId);
            }}
          >
            {record.name}
          </Button>
        ),
      },
      {
        title: t("accused_police_station"),
        dataIndex: "residence_district_name",
        sorter: (a, b) =>
          a.residence_district_name.localeCompare(b.residence_district_name),
      },
      {
        title: t("crime_police_station"),
        dataIndex: "crime_district_name",
        sorter: (a, b) =>
          a.crime_district_name.localeCompare(b.crime_district_name),
      },
      {
        title: t("total_crimes"),
        dataIndex: "total_count",
        sorter: (a, b) => a.total_count - b.total_count,
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => this.onGunaForm(record.masterId)}
            >
              {record.total_count}
            </Button>
          </div>
        ),
      },
      {
        title: t("title"),
        dataIndex: "main_crime_title",
        sorter: (a, b) => a.main_crime_title.localeCompare(b.main_crime_title),
      },
      {
        title: t("preventive_action"),
        key: "preventive_records",
        width: 120,
        align: "center",
        filters: [
          { text: t("completed"), value: "completed" },
          { text: t("ongoing"), value: "ongoing" },
          { text: t("not_available"), value: "-" },
        ],
        onFilter: (value, record) => getPreventiveStatusKey(record) === value,
        sorter: (a, b) => {
          const order = { completed: 0, ongoing: 1, "-": 2 };
          return (
            order[getPreventiveStatusKey(a)] - order[getPreventiveStatusKey(b)]
          );
        },
        onHeaderCell: () => ({
          style: {
            color: "#000",
            fontWeight: "bold",
          },
        }),

        render: (text, record) => {
          const statusKey = getPreventiveStatusKey(record);

          if (statusKey === "-") {
            return {
              props: { style: { color: "#000" } },
              children: <div className="action-links-responsive">-</div>,
            };
          }

          const statusLabel = t(statusKey);
          const statusColor =
            statusKey === "completed"
              ? "rgb(250, 173, 20)"
              : statusKey === "ongoing"
                ? "rgb(82, 196, 26)"
                : "#000";

          return {
            props: { style: { color: statusColor } },
            children: (
              <div className="action-links-responsive">
                <span
                  className={`preventive-status-label preventive-link-${statusKey}`}
                  style={{ color: statusColor }}
                >
                  {statusLabel}
                </span>
              </div>
            ),
          };
        },
      },
    ];

    const movementDetailColumns = [
      {
        title: t("sr.no"),
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: "फोटो",
        dataIndex: "photo",
        width: 72,
        render: (photo) => {
          const src =
            photo && String(photo).trim()
              ? /^https?:\/\//i.test(String(photo).trim())
                ? String(photo).trim()
                : `https://pcimageupload.s3.ap-south-1.amazonaws.com/${String(photo).replace(/^\//, "")}`
              : null;
          return src ? (
            <img
              alt=""
              style={{
                width: 50,
                height: 50,
                objectFit: "cover",
                borderRadius: 8,
              }}
              src={src}
            />
          ) : (
            <span>{t("no")}</span>
          );
        },
      },
      {
        title: "आरोपी नाव",
        dataIndex: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        render: (text, record) => (
          <Button
            type="link"
            title={record.masterId}
            onClick={() => {
              this.onViewAccusedForm(record.masterId);
            }}
          >
            {record.name}
          </Button>
        ),
      },
      {
        title: "वय",
        dataIndex: "age",
        width: 64,
        sorter: (a, b) => a.age - b.age,
      },
      {
        title: t("accused_police_station"),
        dataIndex: "residence_district_name",
        sorter: (a, b) =>
          a.residence_district_name.localeCompare(b.residence_district_name),
      },
      {
        title: "गुन्हे केलेले ठिकाण",
        dataIndex: "crime_district_name",
        sorter: (a, b) =>
          a.crime_district_name.localeCompare(b.crime_district_name),
      },

      {
        title: "मुख्य गुन्हा",
        dataIndex: "crime_title",
        ellipsis: true,
        sorter: (a, b) => a.crime_title.localeCompare(b.crime_title),
      },
      {
        title: t("preventive_action"),
        key: "preventive_records",
        width: 120,
        align: "center",
        filters: [
          { text: t("completed"), value: "completed" },
          { text: t("ongoing"), value: "ongoing" },
          { text: t("not_available"), value: "-" },
        ],
        onFilter: (value, record) => getPreventiveStatusKey(record) === value,
        sorter: (a, b) => {
          const order = { completed: 0, ongoing: 1, "-": 2 };
          return (
            order[getPreventiveStatusKey(a)] - order[getPreventiveStatusKey(b)]
          );
        },
        onHeaderCell: () => ({
          style: {
            color: "#000",
            fontWeight: "bold",
          },
        }),

        render: (text, record) => {
          const statusKey = getPreventiveStatusKey(record);

          if (statusKey === "-") {
            return {
              props: { style: { color: "#000" } },
              children: <div className="action-links-responsive">-</div>,
            };
          }

          const statusLabel = t(statusKey);
          const statusColor =
            statusKey === "completed"
              ? "rgb(250, 173, 20)"
              : statusKey === "ongoing"
                ? "rgb(82, 196, 26)"
                : "#000";

          return {
            props: { style: { color: statusColor } },
            children: (
              <div className="action-links-responsive">
                <span
                  className={`preventive-status-label preventive-link-${statusKey}`}
                  style={{ color: statusColor }}
                >
                  {statusLabel}
                </span>
              </div>
            ),
          };
        },
      },
    ];

    const leftItems = [
      { name: "कोतवाली", count: 18, icon: <BankOutlined /> },
      { name: "एमआयडीसी", count: 11, icon: <ShoppingOutlined /> },
      { name: "सुपा", count: 8, icon: <TeamOutlined /> },
      { name: "राहूरी", count: 5, icon: <EnvironmentOutlined /> },
    ];

    const rightItems = [
      { name: "राहूरी", count: 14, icon: <EnvironmentOutlined /> },
      { name: "संगमनेर", count: 9, icon: <TeamOutlined /> },
      { name: "कोतवाली", count: 5, icon: <BankOutlined /> },
      { name: "नेवासा", count: 3, icon: <EnvironmentOutlined /> },
    ];

    const data = [
      {
        key: 1,
        sr: 1,
        name: "राजू पाटील",
        stay: "तोफखाना",
        crime: "कोतवाली",
        count: 3,
        type: "घरफोडी",
        category: "बाहेरील",
      },
      {
        key: 2,
        sr: 2,
        name: "इमरान शेख",
        stay: "तोफखाना",
        crime: "एमआयडीसी",
        count: 2,
        type: "वाहन चोरी",
        category: "बाहेरील",
      },
      {
        key: 3,
        sr: 3,
        name: "अमोल जाधव",
        stay: "राहुरी",
        crime: "तोफखाना",
        count: 4,
        type: "चेन स्नॅचिंग",
        category: "येणारे",
      },
      {
        key: 4,
        sr: 4,
        name: "गणेश काळे",
        stay: "संगमनेर",
        crime: "तोफखाना",
        count: 2,
        type: "फसवणूक",
        category: "येणारे",
      },
      {
        key: 5,
        sr: 5,
        name: "सुनील शिंदे",
        stay: "तोफखाना",
        crime: "तोफखाना",
        count: 5,
        type: "घरफोडी",
        category: "स्थानिक",
      },
    ];

    return (
      <>
        {this.props.user.role === "2" && (
          <>
            <div
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: 12,
                border: "1px solid #dfe6f1",
              }}
            >
              {/* Top Header */}
              <Row
                justify="space-between"
                align="middle"
                style={{ marginBottom: 12 }}
              >
                <Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      fontWeight: 600,
                      fontSize: 18,
                      color: "#0b2a66",
                    }}
                  >
                    <EnvironmentOutlined />
                    <span>पो. स्टे. : </span>
                    {list?.districtName}
                    <span>({list?.cityName})</span>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="dashboard-wrapper">
              {/* TOP SECTION — fluid grid (replaces fixed 24-span row) */}
              <div className="dashboard-filter-grid">
                <div className="dashboard-filter-field">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ marginBottom: 5 }}>
                      शीर्षक / लघुशीर्षक / कायदा-कलम निवडा
                    </label>

                    <Select
                      placeholder="Select Title"
                      onChange={this.handleAdvancedFilterTitleChange}
                      value={advancedFilterTitle}
                      style={{ width: "100%" }}
                    >
                      <Option value="शीर्षक">{t("title")}</Option>
                      <Option value="लघु शीर्षक">{t("sub_title")}</Option>
                      <Option value="मोडस">{t("modus_operandi")}</Option>
                      <Option value="कायदा">{`${t("law")} / ${t("section")}`}</Option>
                    </Select>
                  </div>
                </div>

                {advancedFilterTitle === "शीर्षक" && (
                  <div className="dashboard-filter-field">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: 5 }}>शीर्षक निवडा</label>

                      <Select
                        mode="multiple"
                        placeholder="Please select Crime Type"
                        value={selectedHeadings}
                        onChange={(val) =>
                          this.setState({ selectedHeadings: val })
                        }
                        showSearch
                        maxTagCount={1}
                        style={{ width: "100%" }}
                      >
                        {pc_crimetitles?.map((res) => (
                          <Option key={res.id} value={res.id}>
                            {res.crime_title}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                {advancedFilterTitle === "लघु शीर्षक" && (
                  <div className="dashboard-filter-field">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: 5 }}>
                        लघु शीर्षक निवडा
                      </label>

                      <Select
                        mode="multiple"
                        placeholder="Please select Crime Type"
                        value={crimeTitle}
                        onChange={(val) => this.setState({ crimeTitle: val })}
                        showSearch
                        maxTagCount={1}
                        style={{ width: "100%" }}
                      >
                        {pc_crimetypes?.map((res) => (
                          <Option key={res.id} value={res.id}>
                            {res.crimetype}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                {advancedFilterTitle === "मोडस" && (
                  <div className="dashboard-filter-field">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: 5 }}>मोडस निवडा</label>

                      <Select
                        mode="multiple"
                        allowClear
                        value={this.state.crimeTitle}
                        onChange={this.handleCrimeChange}
                        style={{ width: "100%" }}
                        placeholder="Please select option"
                        optionFilterProp="children"
                        maxTagCount={1}
                        showSearch
                      >
                        <Select.Option value="all">All</Select.Option>

                        {main_head?.map((item) => (
                          <Select.Option
                            key={String(item.title_id)}
                            value={String(item.title_id)}
                          >
                            {item.main_head_type}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                {advancedFilterTitle === "कायदा" && (
                  <div className="dashboard-filter-field">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: 5 }}>कायदा निवडा</label>

                      <Select
                        allowClear
                        placeholder={t("please_select_an_option")}
                        value={this.state.kayda}
                        onChange={(val) => this.handleKala(val)}
                        showSearch
                        style={{ width: "100%" }}
                      >
                        {this.props.professionals?.pc_acts?.map((item) => (
                          <Option key={item.act_cd} value={item.act_cd}>
                            {item.kayda}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                {advancedFilterTitle === "कायदा" && this.state.kayda && (
                  <div className="dashboard-filter-field">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ marginBottom: 5 }}>कलम निवडा</label>

                      <Select
                        mode="multiple"
                        allowClear
                        placeholder="Please select option"
                        value={this.state.kalam}
                        onChange={(val) => this.setState({ kalam: val })}
                        showSearch
                        maxTagCount={1}
                        style={{ width: "100%" }}
                      >
                        {this.props.professionals?.pc_kalams?.map((item) => (
                          <Option key={item.section} value={item.section}>
                            {item.section}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}

                <div className="dashboard-filter-field dashboard-filter-field--period">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                    }}
                  >
                    <label>कालावधी निवडा</label>

                    <Select
                      value={this.state.dateFilter}
                      style={{ width: "100%" }}
                      onChange={this.handleDateFilterChange}
                    >
                      <Select.Option value="1month">1 Month</Select.Option>

                      <Select.Option value="6month">6 Months</Select.Option>

                      <Select.Option value="1year">1 Year</Select.Option>

                      <Select.Option value="custom">Custom Date</Select.Option>
                    </Select>
                  </div>
                </div>

                <div className="dashboard-filter-field dashboard-filter-field--daterange">
                  <RangePicker
                    style={{ width: "100%" }}
                    format="DD-MM-YYYY"
                    value={this.state.customDates}
                    onChange={(dates) =>
                      this.setState({
                        customDates: dates,
                      })
                    }
                    disabled={this.state.dateFilter !== "custom"}
                  />
                </div>

                <div className="dashboard-filter-field dashboard-filter-field--submit">
                  <Button
                    type="primary"
                    loading={newDashboardLoading}
                    onClick={() => this.NewDashboard()}
                  >
                    Find
                  </Button>
                </div>
              </div>

              <Spin spinning={newDashboardLoading}>
                <div className="dashboard-stats-grid">
                  <Card className="top-card">
                    <div className="top-flex">
                      <div className="icon-circle blue-circle">
                        <AimOutlined />
                      </div>

                      <div>
                        <p className="card-title">
                          हद्दीत राहून
                          <br />
                          बाहेर गुन्हे करणारे
                        </p>

                        <h1 className="blue-text">{list?.outsider_count}</h1>
                      </div>
                    </div>
                  </Card>

                  <Card className="top-card">
                    <div className="top-flex">
                      <div className="icon-circle green-circle">
                        <EnvironmentOutlined />
                      </div>

                      <div>
                        <p className="card-title">
                          बाहेरून येऊन
                          <br />
                          हद्दीत गुन्हे करणारे
                        </p>

                        <h1 className="green-text">{list?.inside_count}</h1>
                      </div>
                    </div>
                  </Card>

                  <Card className="top-card">
                    <div className="top-flex">
                      <div className="icon-circle orange-circle">
                        <SyncOutlined />
                      </div>

                      <div>
                        <p className="card-title">
                          हद्दीत राहणारे व
                          <br />
                          हद्दीत गुन्हे करणारे
                        </p>

                        <h1 className="orange-text">{list?.same_count}</h1>
                      </div>
                    </div>
                  </Card>
                </div>

                {/* MIDDLE */}
                {list?.movement_outsider_count?.length > 0 ||
                list?.movemen_inside_count?.length > 0 ||
                list?.movement_same_count?.length > 0 ? (
                  <>
                    <Row
                      gutter={[16, 16]}
                      style={{ marginTop: 8, width: "100%" }}
                      align="stretch"
                      className="dashboard-middle-row"
                    >
                      {/* LEFT */}

                      <Col xs={24} lg={12} className="dashboard-middle-col">
                        <Card title="आरोपी हालचाल प्रवाह" className="main-card">
                          <div className="movement-dashboard movement-dashboard--animate">
                            {/* Legend */}
                            <div className="legend-container">
                              <div className="legend-item blue">
                                बाहेर जाणारे आरोपी
                              </div>
                              <div className="legend-item orange">
                                स्थानिक आरोपी
                              </div>
                              <div className="legend-item green">
                                बाहेरून येणारे आरोपी
                              </div>
                            </div>

                            <MovementFlowMap
                              hubDistrict={list?.districtName}
                              hubCount={list?.same_count}
                              hubTitle="हद्दीत राहणारे व हद्दीत गुन्हे करणारे"
                              outsiders={outsiders}
                              insiders={insiders}
                              onNodeClick={(type, item) =>
                                this.openMovementCardDetail(type, item)
                              }
                            />

                            {/* Footer Breakup */}
                            <div className="breakdown-footer">
                              <p className="breakdown-title">
                                स्थानिक आरोपी ब्रेकअप
                              </p>
                              <div className="breakdown-items">
                                {list?.same_local_modus_top4.length > 0 &&
                                  list?.same_local_modus_top4.map((item) => (
                                    <div className="item">
                                      <BankOutlined /> {item.modus_name}{" "}
                                      {item.count}
                                    </div>
                                  ))}
                              </div>
                              {list?.same_local_modus_top4.length == 0 && (
                                <div className="item">
                                  <BankOutlined /> घरफोडी 0
                                </div>
                              )}
                            </div>
                          </div>
                        </Card>
                      </Col>

                      {/* RIGHT GRAPH */}

                      <Col xs={24} lg={12} className="dashboard-middle-col">
                        <Card
                          title="लघुशीर्षक निहाय"
                          className="main-card dashboard-heading-bar-card"
                        >
                          <Radio.Group
                            className="dashboard-heading-bar-radios"
                            value={headingBarMovementTab}
                            onChange={(e) =>
                              this.setState({
                                headingBarMovementTab: e.target.value,
                              })
                            }
                          >
                            <Radio
                              value="outsider"
                              disabled={
                                !(
                                  list?.heading_top_by_basic_heading?.outsider
                                    ?.length > 0 ||
                                  (list?.year_wise_movement_counts || []).some(
                                    (y) => Number(y.outsider_count ?? 0) > 0,
                                  )
                                )
                              }
                            >
                              <span className="blue-text">
                                <b>हद्दीत राहून बाहेर गुन्हे करणारे</b>
                              </span>
                            </Radio>
                            <Radio
                              value="inside"
                              disabled={
                                !(
                                  list?.heading_top_by_basic_heading?.inside
                                    ?.length > 0 ||
                                  (list?.year_wise_movement_counts || []).some(
                                    (y) => Number(y.inside_count ?? 0) > 0,
                                  )
                                )
                              }
                            >
                              <span className="green-text">
                                <b>बाहेरून येऊन हद्दीत गुन्हे करणारे</b>
                              </span>
                            </Radio>
                            <Radio
                              value="same"
                              disabled={
                                !(
                                  list?.heading_top_by_basic_heading?.same
                                    ?.length > 0 ||
                                  (list?.year_wise_movement_counts || []).some(
                                    (y) => Number(y.same_count ?? 0) > 0,
                                  )
                                )
                              }
                            >
                              <span className="orange-text">
                                <b>हद्दीत राहणारे व हद्दीत गुन्हे करणारे</b>
                              </span>
                            </Radio>
                          </Radio.Group>

                          {(() => {
                            const hb = list?.heading_top_by_basic_heading;
                            const rows =
                              headingBarMovementTab === "outsider"
                                ? hb?.outsider || []
                                : headingBarMovementTab === "inside"
                                  ? hb?.inside || []
                                  : hb?.same || [];
                            const countKey =
                              headingBarMovementTab === "outsider"
                                ? "outsider_count"
                                : headingBarMovementTab === "inside"
                                  ? "inside_count"
                                  : "same_count";
                            const headingBarColor =
                              headingBarMovementTab === "outsider"
                                ? "#1e88e5"
                                : headingBarMovementTab === "inside"
                                  ? "#43a047"
                                  : "#fb8c00";
                            const chartData = rows.map((r, idx) => {
                              const full = r.heading_name || "—";
                              const short =
                                full.length > 26
                                  ? `${full.slice(0, 26)}…`
                                  : full;
                              return {
                                key: String(r.heading_id ?? idx),
                                name: short,
                                fullName: full,
                                count: Number(r[countKey] ?? 0),
                              };
                            });
                            const barChartHeight = Math.min(
                              Math.max((chartData.length || 1) * 44, 240),
                              480,
                            );
                            if (!chartData.length) {
                              return (
                                <div className="dashboard-heading-bar-empty">
                                  <Empty
                                    description="या प्रवाहासाठी शीर्षक डेटा उपलब्ध नाही"
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  />
                                </div>
                              );
                            }
                            return (
                              <div className="dashboard-heading-bar-chart-wrap">
                                <ResponsiveContainer
                                  width="100%"
                                  height={barChartHeight}
                                >
                                  <BarChart
                                    layout="vertical"
                                    data={chartData}
                                    margin={{
                                      top: 6,
                                      right: 20,
                                      left: 8,
                                      bottom: 6,
                                    }}
                                  >
                                    <CartesianGrid
                                      strokeDasharray="3 3"
                                      horizontal={false}
                                    />
                                    <XAxis
                                      type="number"
                                      tick={{ fontSize: 11 }}
                                      allowDecimals={false}
                                    />
                                    <YAxis
                                      type="category"
                                      dataKey="name"
                                      width={132}
                                      interval={0}
                                      tick={{ fontSize: 10 }}
                                    />
                                    <Tooltip
                                      formatter={(value) => [value, "संख्या"]}
                                      labelFormatter={(_, payload) =>
                                        payload?.[0]?.payload?.fullName ?? ""
                                      }
                                    />
                                    <Bar
                                      dataKey="count"
                                      fill={headingBarColor}
                                      radius={[0, 6, 6, 0]}
                                      name="संख्या"
                                      maxBarSize={28}
                                    />
                                  </BarChart>
                                </ResponsiveContainer>
                              </div>
                            );
                          })()}

                          <div className="dashboard-year-bar-section">
                            <p className="dashboard-year-bar-title">
                              वर्ष निहाय
                            </p>
                            {(() => {
                              const yearRows =
                                list?.year_wise_movement_counts || [];
                              const yearMovementLabel =
                                headingBarMovementTab === "outsider"
                                  ? "हद्दीत राहून बाहेर गुन्हे करणारे"
                                  : headingBarMovementTab === "inside"
                                    ? "बाहेरून येऊन हद्दीत गुन्हे करणारे"
                                    : "हद्दीत राहणारे व हद्दीत गुन्हे करणारे";
                              const yearXAxisLabel = `आरोपी संख्या : ${yearMovementLabel}`;
                              const yearCountKey =
                                headingBarMovementTab === "outsider"
                                  ? "outsider_count"
                                  : headingBarMovementTab === "inside"
                                    ? "inside_count"
                                    : "same_count";
                              const yearBarColor =
                                headingBarMovementTab === "outsider"
                                  ? "#5c6bc0"
                                  : headingBarMovementTab === "inside"
                                    ? "#26a69a"
                                    : "#ab47bc";
                              const yearChartData = yearRows.map((r) => ({
                                key: String(r.year),
                                name: String(r.year),
                                periodLabel: `${r.startDate} – ${r.endDate}`,
                                count: Number(r[yearCountKey] ?? 0),
                              }));
                              const yearBarChartHeight = Math.min(
                                Math.max((yearChartData.length || 1) * 48, 160),
                                360,
                              );
                              if (!yearChartData.length) {
                                return (
                                  <div className="dashboard-heading-bar-empty">
                                    <Empty
                                      description="वर्ष निहाय डेटा उपलब्ध नाही"
                                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    />
                                  </div>
                                );
                              }
                              return (
                                <div className="dashboard-heading-bar-chart-wrap">
                                  <ResponsiveContainer
                                    width="100%"
                                    height={yearBarChartHeight}
                                  >
                                    <BarChart
                                      layout="vertical"
                                      data={yearChartData}
                                      margin={{
                                        top: 6,
                                        right: 20,
                                        left: 8,
                                        bottom: 52,
                                      }}
                                    >
                                      <CartesianGrid
                                        strokeDasharray="3 3"
                                        horizontal={false}
                                      />
                                      <XAxis
                                        type="number"
                                        tick={{ fontSize: 13 }}
                                        allowDecimals={false}
                                        label={{
                                          value: yearXAxisLabel,
                                          position: "insideBottom",
                                          offset: -8,
                                          style: {
                                            fontSize: 13,
                                            fill: "#37474f",
                                            fontWeight: 700,
                                            textAnchor: "middle",
                                          },
                                        }}
                                      />
                                      <YAxis
                                        type="category"
                                        dataKey="name"
                                        width={52}
                                        interval={0}
                                        tick={{ fontSize: 13, fontWeight: 600 }}
                                      />
                                      <Tooltip
                                        formatter={(value) => [value, "संख्या"]}
                                        labelFormatter={(_, payload) => {
                                          const p = payload?.[0]?.payload;
                                          if (!p) return "";
                                          return `${p.name} (${p.periodLabel})`;
                                        }}
                                      />
                                      <Bar
                                        dataKey="count"
                                        fill={yearBarColor}
                                        radius={[0, 6, 6, 0]}
                                        name="संख्या"
                                        maxBarSize={32}
                                      />
                                    </BarChart>
                                  </ResponsiveContainer>
                                </div>
                              );
                            })()}
                          </div>
                        </Card>
                      </Col>
                    </Row>

                    {/* SUMMARY — three equal columns (Ant grid 8+8+8) */}
                    <div className="dashboard-summary-grid">
                      <Card className="summary-card">
                        <h4>सर्वाधिक बाहेर जाणारे आरोपी:</h4>

                        <p>
                          {list?.districtName} →{" "}
                          {list?.top_movement_outsider_count}
                        </p>
                      </Card>

                      <Card className="summary-card">
                        <h4>सर्वाधिक येणारा स्रोत:</h4>

                        <p>
                          {list?.top_movemen_inside_count} →{" "}
                          {list?.districtName}
                        </p>
                      </Card>

                      <Card className="summary-card">
                        <h4>स्थानिक प्रमुख प्रवाह:</h4>

                        <p>
                          {list?.districtName} → {list?.top_movement_same_count}
                        </p>
                      </Card>
                    </div>
                    {/* TABLE */}
                    {showTopAccusedTable && (
                      <Card
                        title="Top आरोपी तपशील"
                        className="main-card"
                        style={{ marginTop: 16 }}
                      >
                        <Radio.Group
                          className="top-accused-movement-radios"
                          value={topAccusedMovementTab}
                          onChange={(e) =>
                            this.setState({
                              topAccusedMovementTab: e.target.value,
                            })
                          }
                        >
                          <Radio
                            value="outside"
                            disabled={!topAccusedOutsideRows?.length}
                          >
                            <span className="blue-text">
                              <b>हद्दीत राहून बाहेर गुन्हे करणारे</b>
                            </span>
                          </Radio>
                          <Radio
                            value="inside"
                            disabled={!topAccusedInsideRows?.length}
                          >
                            <span className="green-text">
                              <b>बाहेरून येऊन हद्दीत गुन्हे करणारे</b>
                            </span>
                          </Radio>
                          <Radio
                            value="same"
                            disabled={!topAccusedSameDistrictRows?.length}
                          >
                            <span className="orange-text">
                              <b>हद्दीत राहणारे व हद्दीत गुन्हे करणारे</b>
                            </span>
                          </Radio>
                        </Radio.Group>
                        <Table
                          columns={columns}
                          dataSource={topAccusedTableData}
                          pagination={false}
                          bordered
                          scroll={{ x: 1000 }}
                          rowKey={(r, i) =>
                            r?.id != null
                              ? String(r.id)
                              : `${topAccusedMovementTab}-${i}`
                          }
                        />
                      </Card>
                    )}
                  </>
                ) : (
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col span={24}>
                      <Card
                        className="main-card dashboard-movement-empty-wrap"
                        title="आरोपी हालचाल प्रवाह"
                      >
                        <div className="dashboard-movement-empty-inner">
                          <Empty
                            image={
                              <div
                                className="dashboard-movement-empty-icon"
                                aria-hidden
                              >
                                <PartitionOutlined />
                              </div>
                            }
                            imageStyle={{
                              height: "auto",
                              marginBottom: 12,
                            }}
                            description={
                              <div className="dashboard-movement-empty-copy">
                                <p className="dashboard-movement-empty-title">
                                  या निवडीसाठी हालचाल डेटा सापडला नाही
                                </p>
                                <p className="dashboard-movement-empty-hint">
                                  कालावधी, शीर्षक किंवा इतर फिल्टर बदलून
                                  &quot;Find&quot; वर क्लिक करा.
                                </p>
                              </div>
                            }
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                )}
              </Spin>
            </div>
          </>
        )}
        <Modal
          title={this.renderMovementModalTitle(
            movementModalData,
            movementModalDateRange,
          )}
          visible={movementModalVisible}
          onCancel={this.closeMovementModal}
          footer={null}
          width={95 + "%"}
          destroyOnClose
          className="nd-movement-modal"
        >
          {movementModalLoading ? (
            <div style={{ padding: 40, textAlign: "center" }}>
              <Spin />
            </div>
          ) : movementModalData ? (
            <>
              {this.renderMovementModalToggle()}
              {movementModalView === "list" ? (
                this.getMovementModalRows(movementModalData).length > 0 ? (
                  <Table
                    rowKey={(r) => String(r.gunhaId ?? r.masterId)}
                    columns={movementDetailColumns}
                    dataSource={this.getMovementModalRows(movementModalData)}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "15", "20", "50"],
                      hideOnSinglePage: true,
                    }}
                    scroll={{ x: 960 }}
                    bordered
                    size="small"
                  />
                ) : (
                  <Empty description="डेटा उपलब्ध नाही" />
                )
              ) : (
                this.renderMovementModalAnalysis(movementModalData)
              )}
            </>
          ) : (
            <p>डेटा उपलब्ध नाही.</p>
          )}
        </Modal>
        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={this.props.professionals}
            preventiveAction={this.state.preventiveAction}
          ></ViewFormModel>
        </Modal>
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            name={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            address={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].address
                : ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    professionals,
  };
}

const connectedDashboard = connect(mapStateToProps)(NewDashboard);
export { connectedDashboard as NewDashboard };
